import { Injectable } from '@angular/core';
import { AuthService } from '../../user/services/auth.service';
import { HubConnection } from '@microsoft/signalr';
import { ISignalRService } from './signalr-service.interface';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SignalRWizardService implements ISignalRService {
  
  constructor(private authService: AuthService,private router: Router) {}

  /** @inheritdoc */
  registerOnServerEvents(connection: HubConnection): void {
    connection.on('RegistrationFailComplete', (data : any) => {
      this.router.navigateByUrl('/register/failure' + `?orderId=${data.orderId}&errorCode=${data.errorCode}`);
    });

    connection.on('RegistrationSuccessComplete', (loginResponse: any) => {
      const accessToken = loginResponse.accessToken;
      this.authService.loginUsingToken(accessToken, loginResponse.refreshToken, '/')
    });
  }
}
